/* scroll menu  */
window.addEventListener('scroll', function(){
    const header = document.querySelector('.header');
    const subnav = document.querySelector('.subnav');
    const main = document.getElementById('site-main');
    subnav.classList.toggle("fixed", window.scrollY > header.clientHeight);
    main.classList.toggle("fixed", window.scrollY > header.clientHeight);
  })


document.addEventListener("DOMContentLoaded", addScrollWidth);
window.addEventListener("resize", addScrollWidth);

function addScrollWidth (){
    if(window.screen.width < 799){
        document.querySelector('.navbar-nav-wrap').style.width = (window.innerWidth - 20 ) + 'px';
    }
}
